export default "__VITE_ASSET__CxPLiQiN__ 100w";